import Button from '@jetbrains/ring-ui/components/button/button'
import {H3} from '@jetbrains/ring-ui/components/heading/heading'
import plur from 'plur'

import {getProjectsArg, getSingleProjectArg} from '../../../../../../rest/projects'
import {isArchivedProject} from '../../../../../../selectors'
import {restApi} from '../../../../../../services/rest'
import {ROOT_PROJECT_ID, stringifyId} from '../../../../../../types'
import {emptyArray} from '../../../../../../utils/empty'
import SequenceLoader from '../../../../SequenceLoader/SequenceLoader'
import Subproject from '../../Subproject/Subproject.container'
import styles from '../../Subprojects.css'

import {useAppSelector} from 'src/hooks/react-redux'

type Props = {
  projectId: string
  onHide: () => void
}

export const archivedSubprojectsArg = getProjectsArg(ROOT_PROJECT_ID, {
  withBuildTypes: true,
  archived: 'true',
  withLowNesting: true,
  withDescription: true,
})

export function ArchivedSubprojects({projectId, onHide}: Props) {
  const {archivedProjectIds = emptyArray} = restApi.endpoints.getProjectNormalized.useQuery(
    getSingleProjectArg(projectId),
    {
      selectFromResult: ({data}) => ({
        archivedProjectIds: data?.entities.projectArchivedSubprojectsIds?.[projectId],
      }),
    },
  )
  const projectArchived = useAppSelector(state => isArchivedProject(state, projectId))
  const {archivedSubprojectLoaded} = restApi.endpoints.getAllProjectsNormalized.useQuery(
    archivedSubprojectsArg,
    {selectFromResult: ({data}) => ({archivedSubprojectLoaded: data != null})},
  )
  return archivedSubprojectLoaded ? (
    <div className={styles.archived}>
      <div className={styles.header}>
        <H3 className={styles.title}>
          {archivedProjectIds.length} {plur('Archived Project', archivedProjectIds.length)}
        </H3>
        {!projectArchived && (
          <Button className={styles.hideArchivedProjectsButton} onClick={onHide} text>
            {`hide`}
          </Button>
        )}
      </div>
      <SequenceLoader showFirstLoadingItem withIncrementalRendering>
        {archivedProjectIds.map(({id}) => (
          <Subproject level={0} key={stringifyId(id)} seqKey={stringifyId(id)} projectId={id} />
        ))}
      </SequenceLoader>
    </div>
  ) : null
}
